// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-0163f234]:focus{box-shadow:none !important}.tag-list[data-v-0163f234]{padding-left:20px;list-style-type:none}.tag-list__icon[data-v-0163f234]{padding-right:10px}", ""]);
// Exports
module.exports = exports;
